import { clearSelectedAccountant, clearSelectedAccountantName, clearSelectedClient, clearSelectedClientName, clearSelectedINVOICE, clearSelectedTaxYear } from "../../../store/actions";

import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

export const ClientListRoutesComponent = () => {

const navigate = useNavigate();
const dispatch = useDispatch();

const clearClientId = () => {
  dispatch(clearSelectedClient());
};
const clearClientName = () => {
  dispatch(clearSelectedClientName());
};
const clearAccountantId = () => {
  dispatch(clearSelectedAccountant());
};
const clearAccountantName = () => {
  dispatch(clearSelectedAccountantName());
};
const clearTaxYear = () => {
  dispatch(clearSelectedTaxYear());
};
const clearRefNo = () => {
  dispatch(clearSelectedINVOICE());
};
const ArrayData = [
  {
    label: "Home",
    open: true,
    icon: <HomeOutlinedIcon />,
    items: [
      {
        label: "Client List",
        command: () => {
            navigate("/clients")
            clearClientId();
            clearClientName();
            clearTaxYear();
            clearRefNo();
        },
      },
      {
        label: "Client Setup",
        command: () => {
            navigate("/clients/setup")
        },
      },
    ],
  },
  {
    label: "Logout",
    icon: <LogoutOutlinedIcon />,
    command: () => {
        navigate("/logout")
    },
  },
];
return {
    ClientListRoutes:ArrayData
  }
  }